import React, { useContext } from "react";
import { MdCheckCircle } from "react-icons/md";

import { Task } from "../../helpers/Contexts";

const DataEntry = ({ data }) => {
  const { taskValues, setTaskValues } = useContext(Task);
  if (
    data.status == "open" &&
    data.cpr.document.url &&
    data.cpr.sub_status == "closed-completed_results_obtained"
  ) {
    return (
      <div className="data-entry">
        <label>{"DATA ENTRY "}</label>
        <span id="from">Complete and check the following to close this task</span>
        <br />
        <b>
          Did you update the {data.patientPage}
          with any new information from results or visit summary ?
        </b>
        <br />
        <input
          checked={taskValues.checked.qm}
          onChange={(e) =>
            setTaskValues({
              ...taskValues,
              checked: { ...taskValues.checked, qm: e.target.checked },
            })
          }
          className="form-check-input"
          id="checkbox"
          type="checkbox"
        />
        1.Review/update Health Conditions as needed <br />
        <input
          checked={taskValues.checked.conditions}
          onChange={(e) =>
            setTaskValues({
              ...taskValues,
              checked: { ...taskValues.checked, conditions: e.target.checked },
            })
          }
          className="form-check-input"
          id="checkbox"
          type="checkbox"
        />
        2.Review/update Quality Measurements as needed
        <br />
        <input
          checked={taskValues.checked.cpr}
          onChange={(e) =>
            setTaskValues({
              ...taskValues,
              checked: { ...taskValues.checked, cpr: e.target.checked },
            })
          }
          className="form-check-input"
          id="checkbox"
          type="checkbox"
        />
        3.Review/update Care Plan Requirements (CPRs) as needed
      </div>
    );
  } else {
    return data.cpr.sub_status == "closed-completed_results_obtained" &&
      data.status == "closed" &&
      data.cpr.document.url ? (
      <div className="data-entry mt20-bt">
        <label>Data Entry Completed</label>
        <p>
          <MdCheckCircle className="outcome-icon " /> 1.Reviewed/updated Health Conditions as needed{" "}
          <br />
        </p>
        <p>
          <MdCheckCircle className="outcome-icon " /> 2.Reviewed/updated Quality Measurements as
          needed{" "}
        </p>
        <p>
          <MdCheckCircle className="outcome-icon " /> 3.Reviewed/updated Care Plan Requirements
          (CPRs) as needed
        </p>
      </div>
    ) : (
      ""
    );
  }
};

export default DataEntry;
